import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

enum operazioniSegnalazioni {
  RICEVI_SEGNALAZIONI = 'Ricevi segnalazioni',
  SEGNALAZIONI_NON_RICEVUTE = 'Segnalazioni non ricevute',
  CONFERMA_SEGNALAZIONI = 'Conferma segnalazioni',
  RIFIUTA_SEGNALAZIONI = 'Rifiuta segnalazioni'
}

@Injectable({
  providedIn: 'root'
})
export class SegnalazioniService {

  constructor(private http: HttpClient, private datePipe: DatePipe) { }

  public getList(page: number, size: number, sort: string, ente: number, filters?: ModelEventiCalamitosi.SegnalazioniSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    searchParams = searchParams.append('ente', `${ente}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.SegnalazioneDto[]>(`${environment.urls.base}/segnalazione/list`,
        {
          params: searchParams
        });
  }

  public getListSegnalazioniForEvento(page: number, size: number, sort: string, filters?: ModelEventiCalamitosi.SegnalazioniSearchableDto) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('page', `${page}`);
    searchParams = searchParams.append('size', `${size}`);
    searchParams = searchParams.append('sort', `${sort}`);
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        searchParams = searchParams.append(key, filters[key]);
      }
    }

    return this.http
      .get<ModelEventiCalamitosi.SegnalazioneDto[]>(`${environment.urls.base}/segnalazione/list`,
        {
          params: searchParams
        });
  }

  public getListAnomalieSegnalazione(codiceSegnalazione:number, lastMsgView:boolean) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('codiceSegnalazione', `${codiceSegnalazione}`);
    searchParams = searchParams.append('lastMsgView', `${lastMsgView}`);

    return this.http
      .get<ModelEventiCalamitosi.AnomalieSegnalazioneDTO[]>(`${environment.urls.base}/segnalazione/anomalie-list`,
        {
          params: searchParams
        });
  }

  public downloadReportAggregatoSegnalazioni(reportObject: ModelEventiCalamitosi.ExportCsvWrapperDTO): Observable<HttpResponse<Blob>> {

    return this.http
      .post(
        `${environment.urls.base}/segnalazione/download-report-aggregato-segnalazioni`,
        reportObject,
        {
          observe: 'response',
          responseType: 'blob'
        }
      );

  }

  public getNumeroSegnalazioniEsportabili(filters?: ModelEventiCalamitosi.SegnalazioniSearchableDto) {
    let searchParams = new HttpParams();
    for (let key in filters) {
      if (filters[key] !== null && filters[key].toString().trim() !== '') {
        searchParams = searchParams.append(key, filters[key]);
      }
    }
    return this.http
      .get<Number>(`${environment.urls.base}/segnalazione/numero-segnalazioni-esportabili`,
        {
          params: searchParams
        });
  }

  public downloadReportSingolaSegnalazione(idSegnalazione: Number): Observable<HttpResponse<Blob>> {
    return this.http
      .get(`${environment.urls.base}/segnalazione/download-report-singola-segnalazione/${idSegnalazione}`, { responseType: 'blob', observe: 'response' });
  }

  public getSegnalazione(codiceSegnalazione: number) {
    return this.http
      .get<ModelEventiCalamitosi.AnaDatiRaccoltiDTO>(`${environment.urls.base}/segnalazione/id/${codiceSegnalazione}`);
  }

  public getNumeroSegnalazioniInviabili(idEvento: number) {
    return this.http
      .get<Number>(`${environment.urls.base}/segnalazione/numero-segnalazioni-inviabili/${idEvento}`);
  }

  public getSegnalazioneStorica(codiceSegnalazione: number, dataStoricizzazione: Date) {
    return this.http
      .get<ModelEventiCalamitosi.AnaDatiRaccoltiStoricoDTO>(`${environment.urls.base}/segnalazione/id-segnalazione-storica/${codiceSegnalazione}/${dataStoricizzazione}`);
  }

  /*public upsertSegnalazione(eventoDto: ModelEventiCalamitosi.SegnalazioneDto) {
    return this.http
      .post<ModelEventiCalamitosi.SegnalazioneDto>(
        `${environment.urls.base}/segnalazione/upsert`,
        eventoDto,
        {
          observe: 'response'
        }
      );
  }*/
  public upsertSegnalazione(anaDatiRaccoltiDto: ModelEventiCalamitosi.AnaDatiRaccoltiDTO) {
    return this.http
      .post<ModelEventiCalamitosi.AnaDatiRaccoltiDTO>(
        `${environment.urls.base}/segnalazione/upsert`,
        anaDatiRaccoltiDto,
        {
          observe: 'response'
        }
      );
  }

  public deleteSegnalazione(codiceSegnalazione: number) {
    return this.http.delete<ModelEventiCalamitosi.SegnalazioneDto>(`${environment.urls.base}/segnalazione/delete/${codiceSegnalazione}`)
  }

  public getTemplatePerCompilazione(idEvento: number, idSegnalazione?: number) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('idEvento', `${idEvento}`);
    if (idSegnalazione != undefined) {
      searchParams = searchParams.append('idSegnalazione', `${idSegnalazione}`);
    }

    return this.http
      .get<ModelEventiCalamitosi.TemplateDto[]>(`${environment.urls.base}/segnalazione/list-template-compilazione`,
        {
          params: searchParams
        });
  }

  public changeStatusSegnalazione(segnalazione:ModelEventiCalamitosi.SegnalazioneStatusDTO) {
    return this.http
    .post<ModelEventiCalamitosi.AnaDatiRaccoltiDTO>(
      `${environment.urls.base}/segnalazione/compila-segnalazione`,
      segnalazione,
      {
        observe: 'response'
      }
    );
    }

    changeStatusSegnalazioniMassivo(segnalazioniUpdateMassivaDto: ModelEventiCalamitosi.SegnalazioniUpdateMassivaDTO) {
      return this.http
      .post<ModelEventiCalamitosi.AnaDatiRaccoltiDTO>(
        `${environment.urls.base}/segnalazione/change-status-massivo`,
        segnalazioniUpdateMassivaDto,
        {
          observe: 'response'
        }
      );
    }

    getNumeroSegnalazioniPerEvento(segnalazioneFilter: ModelEventiCalamitosi.SegnalazioniSearchableDto) {
      let searchParams = new HttpParams();
      for (let key in segnalazioneFilter) {
        if (segnalazioneFilter[key] !== null && segnalazioneFilter[key].toString().trim() !== '') {
          searchParams = searchParams.append(key, segnalazioneFilter[key]);
        }
      }
      return this.http
      .get<Number>(`${environment.urls.base}/segnalazione/numero-segnalazioni-evento`,
        {
          params: searchParams
        });
    }

    checkIfEditabile(idTemplate:number) {
      return this.http
        .get<{canDgpeUpdate:boolean, canDpcplUpdate: boolean, canUpdate: boolean}>(`${environment.urls.base}/segnalazione/is-editabile/${idTemplate}`);
    }

    segnalazioneHasErrors(idSegnalazione: number) {
      return this.http
      .get<number>(`${environment.urls.base}/segnalazione/check-anomalie-segnalazione/${idSegnalazione}`);
    }

    getOperazioni(): ModelEventiCalamitosi.OperazioniSegnalazioni[] {
      let ops: ModelEventiCalamitosi.OperazioniSegnalazioni[] = [];
      ops.push({idOperazione:"RICEVI_SEGNALAZIONI", descOperazione: operazioniSegnalazioni.RICEVI_SEGNALAZIONI})
      ops.push({idOperazione:"SEGNALAZIONI_NON_RICEVUTE", descOperazione: operazioniSegnalazioni.SEGNALAZIONI_NON_RICEVUTE})
      ops.push({idOperazione:"CONFERMA_SEGNALAZIONI", descOperazione: operazioniSegnalazioni.CONFERMA_SEGNALAZIONI})
      ops.push({idOperazione:"RIFIUTA_SEGNALAZIONI", descOperazione: operazioniSegnalazioni.RIFIUTA_SEGNALAZIONI})
      return ops;
    }
}


